import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Internal debug panel is gated by the `debug` role in public.user_roles.
// Grant via SQL: INSERT INTO user_roles (user_id, role) VALUES (<uid>, 'debug');
// RLS allows each user to read only their own role rows, so this query is safe.
export function useDebugMode() {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async (userId: string | undefined) => {
      if (!userId) {
        if (!cancelled) setEnabled(false);
        return;
      }
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", userId)
        .eq("role", "debug")
        .maybeSingle();
      if (!cancelled) setEnabled(!error && !!data);
    };

    supabase.auth.getUser().then(({ data }) => check(data.user?.id));

    const { data: sub } = supabase.auth.onAuthStateChange((_evt, session) => {
      // Defer: querying inside the auth callback deadlocks the auth lock.
      setTimeout(() => check(session?.user?.id), 0);
    });

    return () => {
      cancelled = true;
      sub.subscription.unsubscribe();
    };
  }, []);

  return enabled;
}
